import * as tf from "@tensorflow/tfjs";
import coxParameters from "./outcome_dcm.json";
import dcmScaler from "./scaler_dcm.json";

const significantDimensions = [0, 4, 5, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 21, 22, 24, 25, 26, 29, 30, 31];
const significantSDs = significantDimensions.map((i) => dcmScaler.sd[i]);
const significantMeans = significantDimensions.map((i) => dcmScaler.mean[i]);

async function getCoxPrediction(encoding: number[]): Promise<any> {
  const significantEncoding = significantDimensions.map((i) => encoding[i]);

  return await tf
    .sub(
      1,
      tf.pow(
        coxParameters.baseline_survival,
        tf.exp(tf.dot(tf.tensor1d(coxParameters.coefs), tf.mul(tf.sub(significantEncoding, significantMeans), significantSDs)))
      )
    )
    .array();
}

export default [
  {
    id: "DCM/Outcome",
    value: "DCM/Outcome",
    label: "DCM / Outcome",
    patientGroup: "Patients with DCM at their baseline visit",
    predictedOutcome: "Five-year risk of life threatening ventricular arrhythmias",
    link: "https://dcm.ecgx.ai",
    paper: {
      text: `This model was trained on 695 patients with non-ischemic
        dilated cardiomyopathy at their baseline visit in two academic 
        hospitals to predict the five-year risk of life-threatening
        ventricular arrhythmias (LTVA). Results are published in EP 
        Europace.`,
      link: "https://academic.oup.com/europace/advance-article/doi/10.1093/europace/euac054/6618973?login=false",
    },
    baseValue: 17,
    colors: coxParameters.colors,
    probability: getCoxPrediction,
  },
];
